import * as React from "react";

import {cx}       from "emotion";
import {Link}     from "react-router-dom";

import "./account-tabs-layout.scss";

import {cs}             from "@Common/react/chain-services";
import {keyed}          from "@Common/react/keyed";
import {buildUrlQuery}  from "@Common/utils/build-url-query";
import {AccountLayout}  from "../account-layout/account-layout";
import {Responsive}     from "@Common/ui-components/responsive";

const mobileViewNoTabs = null

export const AccountTabsLayout = <TabName extends string,>({
    activeMenu,
    activeTab,
    config,
    next,
    header=undefined,
    mobileHeader=undefined,
    mobileOfficeInfo=undefined,
    historyPush=true,
    officeId=undefined,
    overflow=false,
}:{
    activeMenu        : string,
    activeTab         : TabName,
    config            : Array<{name: TabName, link: string, linkLabel: string}>,
    header           ?: JSX.Element,
    mobileHeader     ?: JSX.Element,
    mobileOfficeInfo ?: JSX.Element,
    historyPush      ?: boolean,
    next              : () => JSX.Element,
    officeId         ?: string,
    overflow         ?: boolean,
}) => cs(
    ({}, next) => AccountLayout({active: activeMenu, overflow: overflow, activeTab: activeTab, next}),
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ({responsive}) => (<>
        {mobileHeader}
        <div className="account-tabs-layout account-tabs-layout-6d6">
            {header}
            {responsive.ge("md") ? (
                config.length > 1 && <div className="header">
                    {config.map((item) => cs(
                        keyed(item.name),
                        () => (
                            <Link
                                className={cx("item", {active: activeTab === item.name})}
                                to={item.link + buildUrlQuery({
                                    ...officeId && {
                                        office: officeId
                                    },
                                })}
                                replace={!historyPush}
                                xd-qa-name={item.linkLabel}
                                xd-qa-type="link"
                            >
                                {item.linkLabel}
                            </Link>
                        ),
                    ))}
                </div>
            ) : mobileViewNoTabs}
            <div className="content">
                {mobileOfficeInfo}
                {next()}
            </div>
        </div>
    </>),
);
